exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-table .title[data-v-75dab457] {\n  color: #99aabb;\n  font-weight: bold;\n}", ""]);

// exports
